import React, { useMemo, Fragment, useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import Typography from "@mui/material/Typography";

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import EditIcon from "@mui/icons-material/Edit";
import { useLocation, useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Stack from "@mui/material/Stack";
import { adminUserCreatePath, adminUserEditPath } from "../../../routes/routePaths";
import MpgErrorDialog from "../../../common/dialog/MpgErrorDialog";
import NoTableDataComp from "../../../common/otherCommonComponents/NoTableDataComp";
import HtmlTooltip from "../../../common/tooltips/HtmlTooltip";
import { useGetLoggedInUserDetails } from "../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import { useGetAllAdminUserListQuery } from "../../../reactQueries/AppApi/rqHooksForAdminUser";
import { useAccessTypes } from "../../../hooksAndFunctions/customHooks/useAccessTypes";
import { useGetSiteCoreCMSData } from "../../../reactQueries/commonRQHooks";


const ViewAdminUser = () => {

  const {
    isEnterpriseAdmin: isEnterpriseAdminType,
    clientPortalAdminType,
    candidatePortalAdminType,
  } = useAccessTypes()

  const { isClientPortalAdmin, hasA1Access, hasA2Access, hasA3Access } = clientPortalAdminType
  const { isCandidatePortalAdmin, hasSuperAdminAccess, hasAdminAccess, hasCoachAccess, hasCoachAdminAccess } = candidatePortalAdminType

  const { isSuccess: isSuccessOnAdminUser, error: errorOnAdminUser, data: adminUserFromAPI, isError: isErrorOnAdminUser, isFetching: isFetchingOnAdminUser } = useGetAllAdminUserListQuery();
  const {isSuccess: isSuccessOnSiteCoreCMS, error: errorOnSiteCoreCMS, data: adminUserCMSDataFromAPI, isError: isErrorOnSiteCoreCMS, isFetching: isFetchingOnSiteCoreCMS} = useGetSiteCoreCMSData({pagename: "Users"});
  const [adminUserCMSData, setAdminUserCMSData] = useState({
    title: "",
    description: "",
    tabNavigationTitle: "",
    pageContent: {},
});

  const fetchAdminUserCMSData = () =>{
     if(adminUserCMSDataFromAPI && adminUserCMSDataFromAPI.Pages){
      adminUserCMSDataFromAPI.Pages.map((el) => {
        if (el.Key === "UserAccounts") {
          const { Title, Description, TabNavigationTitle, Components } = el;
          setAdminUserCMSData({ title: Title, description: Description, tabNavigationTitle: TabNavigationTitle, pageContent: Components });
        }
    });
     }
  }

  const fetchAdminUserDetailsLabel = (key) => {
    if (adminUserCMSData && adminUserCMSData?.pageContent["AdminUserDetails"]) {
        const adminUserCMSDataLabel = adminUserCMSData.pageContent["AdminUserDetails"];
        return returnLabel(adminUserCMSDataLabel?.Labels, key)
    }
    return '';
}

const fetchAdminUserListLabel = (key) => {
  if (adminUserCMSData && adminUserCMSData?.pageContent["AdminUserList"]) {
      const adminUserCMSDataLabel = adminUserCMSData.pageContent["AdminUserList"];
      return returnLabel(adminUserCMSDataLabel?.Labels, key)
  }
  return '';
}

const fetchCommonCMSLabel = (key) => {
  if (adminUserCMSData && adminUserCMSData?.pageContent["CommonComponent"]) {
      const adminUserCMSDataLabel = adminUserCMSData.pageContent["CommonComponent"];
      return returnLabel(adminUserCMSDataLabel?.Labels, key)
  }
  return '';
}

const returnLabel = (labelArray=[], key) => {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
}

const columns = useMemo(
  () => [
    {
      accessorFn: (row) => `${row.lastName} ${row.firstName}` || "",
      id: 'userFullName',
      header:fetchAdminUserListLabel('AdminUserList.Name'),
      muiTableHeadCellFilterTextFieldProps: { placeholder: fetchAdminUserListLabel('AdminUserList.FilterbyName') },
      Cell: ({ renderedCellValue }) => {
        return (
          <HtmlTooltip title={renderedCellValue}>{renderedCellValue}</HtmlTooltip>
        )
      },
      filterFn: 'contains',
    },
    {
      accessorFn: (row) => {
        const val = row.multipleStaffRole
        return !!val ? val.trim() : ""
      },
      id: 'multipleStaffRole',
      header:fetchAdminUserListLabel('AdminUserList.Role'),
      muiTableHeadCellFilterTextFieldProps: { placeholder: fetchAdminUserListLabel('AdminUserList.FilterbyRole') },
      Cell: ({ renderedCellValue }) => {
        return (
          <HtmlTooltip title={renderedCellValue}>{renderedCellValue}</HtmlTooltip>
        )
      },
      filterFn: 'contains'
    },
    {
      accessorFn: (row) => {
        const val = row.emailAddress
        return !!val ? val : ""
      },
      id: 'emailAddress',
      header: fetchAdminUserListLabel('AdminUserList.Email'),
      muiTableHeadCellFilterTextFieldProps: { placeholder: fetchAdminUserListLabel('AdminUserList.FilterbyEmail') },
      Cell: ({ renderedCellValue }) => {
        return (
          <HtmlTooltip title={renderedCellValue}>{renderedCellValue}</HtmlTooltip>
        )
      },
      filterFn: 'contains'
    },
    {
      accessorFn: (row) => {
        const val = row.primaryContactNo
        return !!val ? val : ""
      },
      id: 'primaryContactNo',
      header:fetchAdminUserListLabel("AdminUserList.Phone"),
      muiTableHeadCellFilterTextFieldProps: { placeholder: fetchAdminUserListLabel('AdminUserList.FilterbyPhone') },
      Cell: ({ renderedCellValue }) => {
        return (
          <HtmlTooltip title={renderedCellValue}>{renderedCellValue}</HtmlTooltip>
        )
      },
      filterFn: 'contains'
    },
    {
      accessorKey: "rightOffice",
      header:fetchAdminUserListLabel("AdminUserList.ServiceOffice"),
      muiTableHeadCellFilterTextFieldProps: { placeholder: fetchAdminUserListLabel('AdminUserList.FilterbyServiceOffice') },
      Cell: ({ renderedCellValue }) => {
        return (
          <HtmlTooltip title={renderedCellValue}>{renderedCellValue}</HtmlTooltip>
        )
      },
      filterFn: 'contains'
    },
  ],
  [adminUserCMSData]
);

  /**redirect hook */
  let navigate = useNavigate();
  
 useEffect(() => {
  fetchAdminUserCMSData();
 }, [adminUserCMSDataFromAPI]);

  return (
    <Fragment>
      {
        !!isFetchingOnAdminUser && fetchCommonCMSLabel('Common.Waitloading')
      }
      <Typography variant="h5" align="center" sx={{ fontWeight: "bolder" }}>
        {adminUserCMSData?.title}
      </Typography>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        m={1}
      >
        {
          (!!isEnterpriseAdminType || !!hasA1Access || !!hasSuperAdminAccess) && (
            <Button
              variant="outlined"
              size="small"
              component={Link}
              to={adminUserCreatePath}
            >
              {fetchAdminUserDetailsLabel('AdminUserDetails.CreateNewAdminUser')}
            </Button>
          )
        }

      </Stack>

      {/**incase successful call but empty response */}
      {!!isSuccessOnAdminUser && !adminUserFromAPI?.length && (<NoTableDataComp />)}

      {!!isSuccessOnAdminUser && !!adminUserFromAPI?.length && (
        <MaterialReactTable
          columns={columns}
          data={adminUserFromAPI || []}
          layoutMode="grid"
          enableGlobalFilter={false}
          enableDensityToggle={false}
          initialState={{
            density: "compact",
            showColumnFilters: true,
          }}
          state={{
            isLoading: isFetchingOnAdminUser,
            columnPinning: {
              left: ['mrt-row-actions', 'userFullName']
            }
          }}
          enableStickyHeader
          enableRowActions
          displayColumnDefOptions={{
            'mrt-row-actions': {
              header: fetchAdminUserListLabel('AdminUserList.Actions'), 
            },
          }}
          renderRowActions={({ row, table }) => {
            const Id = row.original.staffId;
            const Status = row?.original.Status;
            return (
              <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                <IconButton
                  onClick={() => {
                    navigate(adminUserEditPath({ id: Id }));
                  }}
                >
                  <EditIcon />
                </IconButton>
              </Box>
            )

          }}
        />
      )}

      <MpgErrorDialog
        open={!!isErrorOnAdminUser}
      />
    </Fragment>
  );
};

export default ViewAdminUser;
